import styled from 'styled-components';
import {
  COLORS,
  borderRadiusSm,
  paddingMd,
  paddingSm,
  paddingXs,
} from 'assets/styled';
import { HAS_IMAGES_BREAKPOINT } from 'utils/hooks/useHasImages';
import { respondTo } from 'assets/styled/breakpoints';

export const Wrapper = styled.div`
  min-height: 700rem;
  max-width: 1400rem;
  width: 100%;
  margin: 50rem 0;
  padding: 0 15rem;
  align-self: center;
  display: flex;
  flex-direction: column;
  gap: 20rem;

  ${respondTo.midTablet`
    margin-bottom: 150rem;
  `}

  ${respondTo.smallPhone`
    margin-bottom: 200rem;
  `}
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${paddingSm};
  justify-content: space-between;
  background-color: ${COLORS.WHITE};
  border-radius: ${borderRadiusSm};
  width: 100%;

  ${respondTo.bigPhone`
    padding: 10rem;
  `};
  margin-bottom: 0rem;
  ${respondTo.smallTablet`
    margin-bottom: 15rem;
  `};
`;

export const ByCodeflexWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: ${paddingMd};
  padding-bottom: ${paddingXs};
`;

export const ByCodeflexText = styled.label`
  position: absolute;
  top: 40rem;
  font-weight: 400;
  font-size: 16rem;
  color: ${COLORS.BLACK};
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  // Display form images above the form questions when screen is small
  @media screen and (max-width: ${HAS_IMAGES_BREAKPOINT}px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const NoModelSelectedWrapper = styled.div`
  gap: 30rem;
  height: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const NoModelSelectedLabel = styled.label`
  text-align: center;
  font-weight: 300;
  font-size: 31rem;
  line-height: 44rem;
  color: ${COLORS.BLACK};
`;
